module.exports = __webpack_public_path__ + "static/media/new_file_dark_icn.ddd7b2a2.png";